import { createContext, useContext } from "solid-js"

export type SairEntryPhase = "checking" | "sign-in" | "pending" | "recovery" | "ready"

// Separate from the view so editing the entry surface cannot replace its context
// identity while a mounted gate is preserved by Solid's development refresh.
export const SairEntryContext = createContext<{
  panel: () => HTMLDivElement | undefined
  report: (phase: SairEntryPhase) => void
}>()

export function useSairEntry() {
  const entry = useContext(SairEntryContext)
  if (!entry) throw new Error("SairEntryProvider is required")
  return entry
}
